var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "md-layout md-gutter md-alignment-center" }, [
        _c("div", {
          staticClass:
            "md-layout-item md-size-10 md-medium-size-10 md-small-size-10 md-xsmall-size-0"
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "md-layout-item md-size-80 md-medium-size-80 md-small-size-80 md-xsmall-size-100"
          },
          [
            _c("div", { staticClass: "row bottom-margin-20" }, [
              _c("div", { staticClass: "col-md-8 col-md-offset-1 confi" }, [
                _c("h2", [_vm._v("IMPRESSUM")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row bottom-margin-20" }, [
              _c("div", { staticClass: "col-md-8 col-md-offset-1 confi" }, [
                _c("h4", [_vm._v("ANBIETER")]),
                _vm._v(" "),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Deutsches Forschungszentrum für Künstliche Intelligenz GmbH,\n              DFKI"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("p", [_c("b", [_vm._v("Standort Kaiserslautern")])]),
                _vm._v(" "),
                _c("p", [_vm._v("Trippstadter Straße 122")]),
                _vm._v(" "),
                _c("p", [_vm._v("D-67663 Kaiserslautern")]),
                _vm._v(" "),
                _c("p", [_vm._v("T: +49 (0)631 / 205 75-0")]),
                _vm._v(" "),
                _c("p", [_vm._v("F: +49 (0)631 / 205 75-5030")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("p", [_c("b", [_vm._v("Standort Saarbrücken")])]),
                _vm._v(" "),
                _c("p", [_vm._v("Campus D3_2")]),
                _vm._v(" "),
                _c("p", [_vm._v("Stuhlsatzenhausweg 3")]),
                _vm._v(" "),
                _c("p", [_vm._v("D-66123 Saarbrücken")]),
                _vm._v(" "),
                _c("p", [_vm._v("T: +49 (0)681 / 857 75-0")]),
                _vm._v(" "),
                _c("p", [_vm._v("F: +49 (0)631 / 857 75-5341")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("p", [
                  _vm._v("Registergericht: Amtsgericht Kaiserslautern")
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("Registernummer: HRB 2313")]),
                _vm._v(" "),
                _c("p", [_vm._v("ID-Nummer: DE 148 646 973")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row bottom-margin-20" }, [
              _c("div", { staticClass: "col-md-8 col-md-offset-1 confi" }, [
                _c("h4", [_vm._v("Geschäftsführung")]),
                _vm._v(" "),
                _c("p", [_vm._v("Prof. Dr. Antonio Krüger")]),
                _vm._v(" "),
                _c("p", [_vm._v("Helmut Ditzer")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-8 col-md-offset-1 confi" }, [
                _c("h4", [_vm._v("VORSITZENDER DES AUFSICHTSRATS")]),
                _vm._v(" "),
                _c("p", [_vm._v("Dr.-Ing. Gabriël Clemens")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row bottom-margin-50" }, [
              _c("h4", [_vm._v("VORSITZENDER DES AUFSICHTSRATS")]),
              _vm._v(" "),
              _c("p", [_vm._v("Dr. Ferri Abolhassan")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row bottom-margin-50" }, [
              _c("h4", [_vm._v("URHEBERRECHTSHINWEIS")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Alle Inhalte dieser Website, insbesondere Texte, Fotografien und\n          Grafiken, sind urheberrechtlich geschützt. Das Urheberrecht liegt\n          bei der DFKI GmbH. Das Material unterliegt dem eingeschränkten\n          Nutzungsrecht und darf nur in Absprache und/oder mit Verweis auf die\n          DFKI GmbH verwendet werden.\n        "
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Mediadaten, die im Pressebereich der Webseite zum Download von uns\n          angeboten werden, dürfen in elektronischen oder gedruckten\n          Publikationen unter Angabe eines Verweises auf die DFKI GmbH\n          verwendet werden.\n        "
                )
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("Saarbrücken, 25.05.2018")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row bottom-margin-20" }, [
              _c("h2", [_vm._v("HAFTUNGSAUSSCHLUSS")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row bottom-margin-50" }, [
              _c("h4", [_vm._v("INHALT DES ONLINEANGEBOTES")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Der Betreiber übernimmt keinerlei Gewähr für die Aktualität,\n          Korrektheit, Vollständigkeit oder Qualität der bereitgestellten\n          Informationen. Haftungsansprüche gegen den Betreiber, welche sich\n          auf Schäden materieller oder ideeller Art beziehen, die durch die\n          Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch\n          die Nutzung fehlerhafter und unvollständiger Informationen\n          verursacht wurden, sind grundsätzlich ausgeschlossen, sofern seitens\n          des Betreibers kein nachweislich vorsätzliches oder grob\n          fahrlässiges Verschulden vorliegt.\n        "
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Alle Angebote sind freibleibend und unverbindlich. Der Betreiber\n          behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte\n          Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu\n          löschen oder die Veröffentlichung zeitweise oder endgültig\n          einzustellen.\n        "
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Trotz sorgfältiger inhaltlicher Kontrolle übernimmt der Betreiber\n          keine Haftung für die Inhalte externer Links.\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row bottom-margin-50" }, [
              _c("h4", [_vm._v("VERWEISE UND LINKS")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Bei direkten oder indirekten Verweisen auf fremde Webseiten\n          (Hyperlinks), die außerhalb des Verantwortungsbereiches des\n          Betreibers liegen, würde eine Haftungsverpflichtung ausschließlich\n          in dem Fall in Kraft treten, in dem der Betreiber von den Inhalten\n          Kenntnis hat und es ihm technisch möglich und zumutbar wäre, die\n          Nutzung im Falle rechtswidriger Inhalte zu verhindern.\n        "
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Der Betreiber erklärt hiermit ausdrücklich, dass zum Zeitpunkt der\n          Linksetzung keine illegalen Inhalte auf den zu verlinkenden Seiten\n          erkennbar waren. Auf die aktuelle und zukünftige Gestaltung, die\n          Inhalte oder die Urheberschaft der gelinkten / verknüpften Seiten\n          hat der Betreiber keinerlei Einfluss. Deshalb distanziert er sich\n          hiermit ausdrücklich von allen Inhalten aller gelinkten /\n          verknüpften Seiten, die nach der Linksetzung verändert wurden. Diese\n          Feststellung gilt für alle innerhalb des eigenen Internetangebotes\n          gesetzten Links und Verweise sowie für Fremdeinträge in vom\n          Betreiber eingerichteten Gästebüchern, Diskussionsforen und\n          Mailinglisten. Für illegale, fehlerhafte oder unvollständige Inhalte\n          und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung\n          solcherart dargebotener Informationen entstehen, haftet allein der\n          Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der\n          über Links auf die jeweilige Veröffentlichung lediglich verweist.\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row bottom-margin-50" }, [
              _c("h4", [_vm._v("URHEBER- UND KENNZEICHENRECHT")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Der Betreiber ist bestrebt, in allen Publikationen die Urheberrechte\n          der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu\n          beachten, von ihm selbst erstellte Grafiken, Tondokumente,\n          Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken,\n          Tondokumente, Videosequenzen und Texte zurückzugreifen. Alle\n          innerhalb des Internetangebotes genannten und ggf. durch Dritte\n          geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den\n          Bestimmungen des jeweils gültigen Kennzeichenrechts und den\n          Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein\n          aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass\n          Markenzeichen nicht durch Rechte Dritter geschützt sind. Das\n          Copyright für veröffentlichte, vom Betreiber selbst erstellte\n          Objekte bleibt allein beim Betreiber. Eine Vervielfältigung oder\n          Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte\n          in anderen elektronischen oder gedruckten Publikationen ist ohne\n          ausdrückliche Zustimmung des Betreibers nicht gestattet.\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row bottom-margin-50" }, [
              _c("h4", [_vm._v("DATENSCHUTZ")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Sofern innerhalb des Internetangebotes die Möglichkeit zur Eingabe\n          persönlicher oder geschäftlicher Daten (E-Mailadressen, Namen,\n          Anschriften) besteht, so erfolgt die Preisgabe dieser Daten seitens\n          des Nutzers auf ausdrücklich freiwilliger Basis. Die Inanspruchnahme\n          und Bezahlung aller angebotenen Dienste ist – soweit technisch\n          möglich und zumutbar – auch ohne Angabe solcher Daten bzw. unter\n          Angabe anonymisierter Daten oder eines Pseudonyms gestattet. Die\n          Nutzung der im Rahmen des Impressums oder vergleichbarer Angaben\n          veröffentlichten Kontaktdaten wie Postanschriften, Telefon- und\n          Faxnummern sowie E-Mailadressen durch Dritte zur Übersendung von\n          nicht ausdrücklich angeforderten Informationen ist nicht gestattet.\n          Rechtliche Schritte gegen die Versender von sogenannten Spam-Mails\n          bei Verstößen gegen dieses Verbot sind ausdrücklich vorbehalten.\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row bottom-margin-50" }, [
              _c("h4", [
                _vm._v("RECHTSWIRKSAMKEIT DIESES HAFTUNGSAUSSCHLUSSES")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Sofern Teile oder einzelne Formulierungen dieses Textes der\n          geltenden Rechtslage nicht, nicht mehr oder nicht vollständig\n          entsprechen sollten, bleiben die übrigen Teile des Dokumentes in\n          ihrem Inhalt und ihrer Gültigkeit davon unberührt.\n        "
                )
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "md-layout-item md-size-10 md-medium-size-10 md-small-size-10 md-xsmall-size-0"
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bb279ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bb279ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/datasecurity/impressum/Impressum.vue
// module id = null
// module chunks = 